"use strict";
exports.__esModule = true;
function default_1(s) {
    s = s.toLowerCase().replace(',', '');
    var numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '-'];
    // for $100 and #123, etc.
    if (numbers.indexOf(s[0]) === -1) {
        s = s.slice(1);
    }
    return !isNaN(parseInt(s, 10));
}
exports["default"] = default_1;
;
